export default __webpack_public_path__ + "locales/tr/Payments.json?hash=5c8e367f12abd91fd25f7c15940b51f8";